import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { ReactNode } from 'react'
import { createQueryClient } from '@/lib/queryClient'

const queryClient = createQueryClient()
// Playwright runs (VITE_E2E=true) render without the devtools button so screenshots are stable.
const SHOW_DEVTOOLS = import.meta.env.VITE_E2E !== 'true'

export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {SHOW_DEVTOOLS ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  )
}
